import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { norecord, saleimg } from "../Constant/Index";
import { Link } from "react-router-dom";
import { testiapi } from "../network/Network";

const Testimonials = () => {
  const [getTesti, setGetTesti] = useState([]);
  const [visiblePics, setVisiblePics] = useState(3);

  const showMorePics = () => {
    setVisiblePics((prevVisiblePics) => prevVisiblePics + 3);
  };

  const Star = ({ filled }) => (
    <span style={{ color: filled ? "#FFD700" : "#ddd", fontSize: "24px" }}>
      ★
    </span>
  );
  //   ======================
  const StarRating = ({ rating, totalStars = 5 }) => {
    return (
      <div style={{ display: "inline-block" }}>
        {Array.from({ length: totalStars }, (_, index) => (
          <Star key={index} filled={index < rating} />
        ))}
      </div>
    );
  };
  //    Get Testionials
  useEffect(() => {
    testiapi()
      .then((res) => {
        setGetTesti(res?.data);
      })
      .catch((err) => {});
  }, []);
  //   ===================

  return (
    <>
      <Header />
      <PageHeader pagename="Testimonials" />
      <section className="testemonial">
        <div className="container">
          <div className="row">
            {getTesti?.length > 0 ? (
              <>
                {getTesti?.slice(0, visiblePics).map((data, gtindex) => {
                  return (
                    <>
                      <div className="col-lg-12 mt-3" key={gtindex}>
                        <div className="content-qty extra-bg-14 radius-20 pe-5 ps-5 p-4 dark-color ">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex gap-3 align-items-center">
                              <img
                                src={data?.image_url}
                                className="img-fluid profie_img"
                                alt=""
                              />
                              <div>
                                <h4 className="primary-medium-font level-7  mb-0">
                                  {data?.name}
                                </h4>
                                <h5 className="primary-medium-font level-8 extra-color-15">
                                  {data?.designation}
                                </h5>
                              </div>
                            </div>
                            <div className="stars">
                              <StarRating rating={2.5} totalStars={5} />{" "}
                            </div>
                          </div>
                          <p className="primary-medium-font level-8 dark-color mt-3">
                            {data?.description}
                          </p>
                          <h4 className="primary-medium-font level-8 extra-color-10">
                            Posted a Month ago
                          </h4>
                        </div>
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              <div className="no_recod_img text-center">
                <img
                  src={norecord}
                  alt="No records available"
                  className="img-fluid text-center "
                />
              </div>
            )}
          </div>
          {visiblePics < getTesti.length && (
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <Link className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none">
                    <span onClick={showMorePics} className="bg-wrapper ">
                      Load more
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Testimonials;
